import { Component, Renderer2, AfterViewInit, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { DialogService } from '@app/services/dialog.service';
import { TicketsService } from '@app/services/tickets.service';
import { ToastService } from '@app/services/toast.service';
import * as moment from 'moment';
import { Observable, Subscription, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr/toastr/toastr.service';
import { BreadcrumbService } from '@app/services/breadcrumb.service';
interface Ticket {
  id: string;
  customerName: string;
  subject: string;
  reportTime: string;
  reportTimeFormatted: string;
  lastUpdate: string;
  status: 'open' | 'closed';
  category: 'company' | 'driver' | 'customer' | 'my' | 'po';
}

interface TicketCounts {
  company: number;
  driver: number;
  customer: number;
  my: number;
  all: number;
  open: number;
  closed: number;
}
@Component({
  selector: 'app-ticket-listing',
  templateUrl: './ticket-listing.component.html',
  styleUrl: './ticket-listing.component.scss'
})
export class TicketListingComponent implements AfterViewInit {
  // Current filters
  currentCategory: 'company' | 'driver' | 'customer' | 'my' | 'po' = 'company';
  currentStatus: 'all' | 'open' | 'close' = 'all';
  searchQuery: string = '';

  // Counts
  counts: any;

  // Tickets data
  tickets: Ticket[] = [
    {
      id: '900836',
      customerName: 'Saandeep',
      subject: 'Test Ticket',
      reportTime: '2025-05-28T10:48:00',
      reportTimeFormatted: 'Wed, May 28, 2025, 10:48 AM',
      lastUpdate: '10:51 AM',
      status: 'closed',
      category: 'customer'
    },
    {
      id: '900845',
      customerName: 'Rahul Sharma',
      subject: 'Payment Issue - Order #1234',
      reportTime: '2026-01-04T09:15:00',
      reportTimeFormatted: 'Sat, Jan 04, 2026, 09:15 AM',
      lastUpdate: '11:20 AM',
      status: 'open',
      category: 'customer'
    },
    {
      id: '900852',
      customerName: 'Priya Patel',
      subject: 'Delivery Delayed - Help Needed',
      reportTime: '2026-01-03T14:30:00',
      reportTimeFormatted: 'Fri, Jan 03, 2026, 02:30 PM',
      lastUpdate: '3:45 PM',
      status: 'open',
      category: 'customer'
    },
    {
      id: '900861',
      customerName: 'Amit Kumar',
      subject: 'Account Access Problem',
      reportTime: '2026-01-02T11:00:00',
      reportTimeFormatted: 'Thu, Jan 02, 2026, 11:00 AM',
      lastUpdate: '12:15 PM',
      status: 'closed',
      category: 'customer'
    },
    {
      id: '900874',
      customerName: 'Neha Singh',
      subject: 'Product Quality Concern',
      reportTime: '2026-01-01T16:20:00',
      reportTimeFormatted: 'Wed, Jan 01, 2026, 04:20 PM',
      lastUpdate: '5:30 PM',
      status: 'open',
      category: 'customer'
    }
  ];

  filteredTickets: any = [];

  // Pagination
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  ticketsInReview: number = 0;
  isLoading: boolean = true;
  private ticketsListSub?: Subscription;
  private searchSubject = new Subject<string>();

  // Show My Tickets header
  showMyTicketsHeader: boolean = false;
  is_shipped_admin: any;
  is_receiving_admin: any;
  admintabval: any;
  isReceivingSide: boolean = false;

  activeContactId: string | number | null = null;
  showCopiedId: string | number | null = null;
  constructor(private router: Router, public authService: AuthServiceService, private ticketService: TicketsService,
    private renderer: Renderer2, private dialog: MatDialog, private dialogService: DialogService, private toast: ToastService, private sharedData: ShareddtaService, private breadcrumbService: BreadcrumbService) { }

  ngAfterViewInit(): void {
    this.sharedData.signalPageReady();
  }

  ngOnInit(): void {
    this.isReceivingSide = this.router.url.includes('/receiving-admin');
    this.breadcrumbService.set([
      { label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', action: () => this.router.navigate([this.isReceivingSide ? '/receiving-admin/dashboard' : '/admin/dashboard']) },
      { label: 'Tickets' }
    ]);
    this.is_shipped_admin = localStorage.getItem('is_shipped_admin')
    this.is_receiving_admin = localStorage.getItem('is_receiving_admin')
    //     if (this.authService._isRoleName === 'reciver-admin') {
    //   sessionStorage.setItem('ticket_selected_tab', 'MT')
    //   sessionStorage.setItem('admin_ticket_selected_tabs', 'RCT')
    //   this.tabName= "MT";
    //   this.tabNames= sessionStorage.getItem('admin_ticket_selected_tabs') || "RCT";
    //    const storedPageData = localStorage.getItem('pageData');
    //   this.tabNames = this.tabNames;
    //   if (storedPageData) {
    //     const pageData = JSON.parse(storedPageData);

    //     if (this.tabName === pageData.tab) {
    //       this.page = pageData.page;
    //       this.tabName = pageData.tab;
    //     } else {
    //       this.page = 0;
    //       this.tabName = this.tabName;
    //     }

    //     console.log('Retrieved Page Data:', pageData);
    //   }
    //   this.customerTicketsList(); // Load data for receiver-admin
    //   return; // Stop execution of rest of the code
    // }

    // Logic for other roles
    if (this.authService._isRoleName === 'superadmin') {
      this.currentCategory = "company";
      const storedPageData = localStorage.getItem('pageDataSAticket');
      this.currentPage = Number(storedPageData);
    } else {
      // Load from sessionStorage or default to 'company'
      this.currentCategory = (sessionStorage.getItem('ticket_selected_tab') as any) || 'company';

      // User requested: Always select All status on visit
      this.currentStatus = 'all';
      localStorage.setItem('ticketstatus', 'all');

      if (this.authService._isRoleName === 'reciver-admin' || this.authService._isRoleName === 'receiving-admin') {
        this.admintabval = sessionStorage.getItem('admin_ticket_selected_tabs') || undefined;
      }
      else {
        this.admintabval = 'APO';

      }
      const storedPageData = localStorage.getItem('pageData');
      this.tabNames = this.admintabval;

      if (storedPageData) {
        const pageData = JSON.parse(storedPageData);
        // Only restore page if the category matches our default 'company'
        if (this.currentCategory === pageData.tab) {
          this.currentPage = pageData.page;
        } else {
          this.currentPage = 1;
        }
      } else {
        this.currentPage = 1;
      }

      if (this.isReceivingSide) {
        if (this.currentCategory !== 'company' && this.currentCategory !== 'po') {
          this.currentCategory = 'company';
        }
      }
    }
    if (this.isReceivingSide) {
      this.showMyTicketsHeader = (this.currentCategory as any === 'company' || this.currentCategory as any === 'po');
    } else {
      this.showMyTicketsHeader = (this.currentCategory as any === 'my');
    }
    // Load data for other roles
    this.ticketsList();

    // Setup debounced search
    this.searchSubject.pipe(
      debounceTime(1000),
      distinctUntilChanged()
    ).subscribe(query => {
      this.currentPage = 1;
      this.ticketsList(undefined, query, false);
    });
  }

  // Switch Category
  switchCategory(category: 'company' | 'driver' | 'customer' | 'my' | 'po'): void {
    sessionStorage.setItem('ticket_selected_tab', category)
    this.currentCategory = category;
    if (this.isReceivingSide) {
      this.showMyTicketsHeader = (category as any === 'company' || category as any === 'po');
    } else {
      this.showMyTicketsHeader = (category as any === 'my');
    }
    this.currentPage = 1;
    this.currentStatus = "all";
    localStorage.setItem('ticketstatus', this.currentStatus);
    localStorage.removeItem('pageData');
    this.ticketsList();
  }

  // Switch Status Filter
  switchStatus(status: 'all' | 'open' | 'close'): void {
    localStorage.setItem('ticketstatus', status);
    localStorage.removeItem('pageData');
    this.currentStatus = status;
    this.currentPage = 1;
    this.ticketsList();
  }

  // Filter Tickets
  filterTickets(): void {
    let filtered = this.tickets;

    // Filter by category
    filtered = filtered.filter(ticket => ticket.category === this.currentCategory);

    // Filter by status
    if (this.currentStatus !== 'all') {
      filtered = filtered.filter(ticket => ticket.status === this.currentStatus);
    }

    // Filter by search query
    if (this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter(ticket =>
        ticket.id.toLowerCase().includes(query) ||
        ticket.customerName.toLowerCase().includes(query) ||
        ticket.subject.toLowerCase().includes(query)
      );
    }

    this.filteredTickets = filtered;
    this.totalItems = filtered.length;
  }

  // Search Tickets
  onSearch(query: string): void {
    this.searchQuery = query;
    this.cross = (this.searchQuery.length > 0);
    this.searchSubject.next(query);
  }

  // Update Counts
  updateCounts(): void {
    // Company tickets
    this.counts.company = this.tickets.filter(t => t.category === 'company').length;

    // Driver tickets
    this.counts.driver = this.tickets.filter(t => t.category === 'driver').length;

    // Customer tickets
    this.counts.customer = this.tickets.filter(t => t.category === 'customer').length;

    // My tickets
    this.counts.my = this.tickets.filter(t => t.category === 'my').length;

    // Status counts for current category
    const categoryTickets = this.tickets.filter(t => t.category === this.currentCategory);
    this.counts.all = categoryTickets.length;
    this.counts.open = categoryTickets.filter(t => t.status === 'open').length;
    this.counts.closed = categoryTickets.filter(t => t.status === 'closed').length;
  }

  // Get Category Name
  getCategoryName(): string {
    const names = {
      'company': 'Company Tickets',
      'driver': 'Driver Tickets',
      'customer': 'Customer Tickets',
      'my': 'My Tickets',
      'po': 'PO Tickets'
    };
    return names[this.currentCategory];
  }

  // Action Methods
  callCustomer(ticket: any, event: Event): void {
    event.stopPropagation();
    const phone = this.getTicketPhone(ticket);
    if (!phone) {
      this.toast.show('error', 'No phone number available');
      return;
    }

    // Toggle popover
    if (this.activeContactId === ticket.id) {
      this.activeContactId = null;
    } else {
      this.activeContactId = ticket.id;
    }
  }

  copyToClipboard(phone: string, event: Event, ticketId: string | number): void {
    event.stopPropagation();
    navigator.clipboard.writeText(phone).then(() => {
      this.showCopiedId = ticketId;
      setTimeout(() => {
        this.showCopiedId = null;
      }, 2000);
    });
  }

  openWhatsApp(phone: string, event: Event): void {
    event.stopPropagation();
    const cleanPhone = phone.replace(/\D/g, '');
    window.open(`https://wa.me/${cleanPhone}`, '_blank');
  }

  initiateCall(phone: string, event: Event): void {
    event.stopPropagation();
    window.location.href = `tel:${phone}`;
  }

  getTicketPhone(ticket: any): string {
    const countryCode = ticket?.country_code || '';
    const phone = (ticket?.mobile_no || '').toString().trim();

    if (countryCode && phone) {
      const formattedCode = countryCode.toString().startsWith('+') ? countryCode : `+${countryCode}`;
      return `${formattedCode} ${phone}`;
    }
    return phone;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.contact-trigger-wrapper')) {
      this.activeContactId = null;
    }
  }

  messageCustomer(ticketId: string): void {
    console.log('Messaging customer for ticket:', ticketId);
    alert('Opening message for ticket: ' + ticketId);
    // TODO: Implement messaging functionality
  }

  // deleteTicket(ticketId: string): void {
  //   const confirmed = confirm('Are you sure you want to delete ticket ' + ticketId + '?');
  //   if (confirmed) {
  //     this.tickets = this.tickets.filter(ticket => ticket.id !== ticketId);
  //     this.updateCounts();
  //     this.filterTickets();
  //   }
  // }

  openCreateTicketModal(): void {
    const basePath = this.isReceivingSide ? '/receiving-admin' : '/admin';
    this.router.navigate([`${basePath}/ticket/create-ticket`], {
      queryParams: { category: this.currentCategory }
    });
  }

  // Pagination
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
    const pageData = {
      page: this.currentPage,
      tab: this.currentCategory
    };
    localStorage.setItem('pageData', JSON.stringify(pageData));
    this.ticketsList()
  }

  nextPage(): void {
    const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    if (this.currentPage < totalPages) {
      this.currentPage++;
    }
    const pageData = {
      page: this.currentPage,
      tab: this.currentCategory
    };
    localStorage.setItem('pageData', JSON.stringify(pageData));
    this.ticketsList();
  }

  getPaginationInfo(): string {
    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
    if (this.totalItems == 0) {
      const start = 0
      return `Showing ${start} - ${end} of ${this.totalItems} Tickets`;
    }
    else {
      return `Showing ${start} - ${end} of ${this.totalItems} Tickets`;
    }
  }

  isPreviousDisabled(): boolean {
    return this.currentPage === 1;
  }

  isNextDisabled(): boolean {
    return this.currentPage * this.itemsPerPage >= this.totalItems;
  }
  goToTicketDetail(ticket: any) {
    const basePath = this.isReceivingSide ? 'receiving-admin' : 'admin';
    const queryParams: any = {};
    if (ticket.schema_name) {
      // User requested: dont send schema in the receving side admin for PO Tickets section
      if (!(this.isReceivingSide && this.currentCategory === 'po')) {
        queryParams.schema = ticket.schema_name;
      }
    }
    if (this.currentCategory === 'company') {
      queryParams.ticket_type = 'nongeneral';
    } else if (this.currentCategory === 'po') {
      queryParams.ticket_type = 'general';
    }
    this.router.navigate([`${basePath}/ticket/detail`, ticket.id], { queryParams });
  }

  cross: boolean = false;
  clearText() {
    this.searchQuery = '';
    this.cross = false;
    this.currentPage = 1;
    this.ticketsList();
  }
  selectedStatus: string = '';
  tabNames: string | undefined = "RCT";
  ticketsList(page?: number, search_text?: string, showLoader: boolean = true) {
    this.ticketsListSub?.unsubscribe();
    if (showLoader) {
      this.isLoading = true;
    }
    this.ticketsListSub = this.ticketService.getTickets(this.currentPage, this.currentCategory, this.currentStatus, this.searchQuery, this.tabNames, this.isReceivingSide).subscribe((data) => {
      if (data.errorMessage == 'Invalid page number') {
        this.currentPage = Math.max(1, this.currentPage - 1);
        localStorage.removeItem('pageData');
        const pageData = {
          page: this.currentPage,
          tab: this.currentCategory
        };
        localStorage.setItem('pageData', JSON.stringify(pageData));
        this.ticketsList()

        return
      }
      if (this.authService.resultCodeError(data)) {
        this.isLoading = false;
        return;
      }
      this.filteredTickets = data?.result?.results;
      this.totalItems = data?.result?.count;
      this.getTicketsCount();
      this.isLoading = false;

    }, (error) => {
      this.authService.dataError(error);
      this.isLoading = false;
    })
  }
  ticketCounts: any = {};
  headerCountsData: any
  getTicketsCount() {
    const countObs = this.isReceivingSide ? this.ticketService.getReciverTicketsCount() : this.ticketService.getTicketsCount();
    countObs.subscribe(
      (data) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        const result = data?.result;
        if (this.isReceivingSide && Array.isArray(result)) {
          const myStats = result.find((item: any) => item.label === 'my');
          this.ticketCounts = {
            'recieving_admin': { count: myStats?.recieving_admin || 0 },
            'product_owner': { count: myStats?.product_owner || 0 }
          };
        } else {
          this.headerCountsData = Array.isArray(result) ? result : [];
          this.ticketCounts = {};
          this.headerCountsData.forEach((item: any) => {
            this.ticketCounts[item.label] = item;
          });
        }

        this.getStatusCount(); // keep your existing logic
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  getStatusCount() {
    this.ticketService.getStatusCount(this.currentCategory, this.tabNames, this.isReceivingSide).subscribe((data) => {
      if (this.authService.resultCodeError(data)) {
        return;
      }
      this.counts = data?.result;
    }, (error) => {
      this.authService.dataError(error);
    })
  }
  convertLastUpdateTime(s: any) {
    return moment(s).format("ddd MMM DD yyyy,h:mm A");
  }
  convertUtcToLocalDate(utcTimestamp: string): string {
    // Remove 'Z' if it is present at the end of the timestamp
    if (utcTimestamp.endsWith('Z')) {
      utcTimestamp = utcTimestamp.slice(0, -1);
    }

    // Parse the UTC timestamp
    const utcDate = new Date(utcTimestamp);

    // Check for invalid date
    if (isNaN(utcDate.getTime())) {
      throw new Error("Invalid time value");
    }

    // Define options for formatting the date
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',  // e.g., Fri
      year: 'numeric',   // e.g., 2024
      month: 'short',    // e.g., Jun
      day: '2-digit'     // e.g., 07
    };

    // Format the date to local time
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(utcDate);

    return formattedDate;
  }


  convertUtcToLocalTime(utcTimeString: string): string {
    const utcDate = new Date(utcTimeString);
    const localTimeString = utcDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return localTimeString;
  }
  userTimeZone: any;
  getUserTimeZone() {
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  formatETDA(etda: string): string {
    // Check if etda includes 'T', if true, format the date, otherwise return etda
    if (etda.includes('T')) {
      const [datePart, timePart] = etda.split('T'); // Splitting date and time parts
      const [year, month, day] = datePart.split('-').map(part => parseInt(part));
      const [timeWithoutSeconds, milliseconds] = timePart.split('.'); // Separating time and milliseconds
      const [hour, minute, second] = timeWithoutSeconds.split(':').map(part => parseInt(part));
      const seconds = parseFloat(second + '.' + milliseconds); // Combining seconds and milliseconds as float

      const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, seconds)); // Creating Date object with UTC date and time
      const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: this.userTimeZone })); // Converting to local timezone dynamically

      const options = {
        hour: 'numeric' as const,
        minute: '2-digit' as const,
        hour12: true // 12-hour format
      };

      return localDate.toLocaleString('en-US', options);
    } else {
      return etda;
    }
  }
  async deleteTicket(notificationId: any, schema_name: any): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Ticket',
      'Are you sure you want to delete this ticket? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      this.ticketService.deleteTicket1(notificationId, schema_name).subscribe(
        (data: any) => {
          this.isLoading = false;
          const sections = data?.sections || {};
          if (this.authService.resultCodeError(data)) {
            return;
          }
          if (data.resultDescription) {
            this.toast.show('success', data.resultDescription);
            this.ticketsList();
          }
        },
        (error: any) => {
          this.isLoading = false;
          this.authService.dataError(error);
        }
      );
    }
  }
  oneIsTrue(data: any[]): boolean {
    // Retrieve the org_email from localStorage
    const orgEmail = localStorage.getItem('org_email');

    if (data && data.length > 0) {
      // Check if there is any unread item with sender_email not matching org_email
      return data.some((el: any) =>
        !el.is_read && el.sender_email !== orgEmail
      );
    } else {
      return false;
    }
  }
}
